import { z } from 'zod';

export const SessionStatuses = ['FUTURE', 'OPEN', 'MISSED', 'FILLED'] as const;

export const SessionStatusSchema = z.enum(SessionStatuses);

export type SessionStatus = z.infer<typeof SessionStatusSchema>;
